import React, { useState, useEffect, useRef } from "react";
import { API } from "aws-amplify";
import ClockGray from "../../../assets/svgjs/ClockGray";
import Cviewstyle from "./courseCreation.module.scss";
import UserHeader from "../../Header/UserHeader/UserHeader";
import { Constants } from "../../../config/constants";
import config from "../../../config/aws-exports";
import { Tab } from "semantic-ui-react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { awsSignIn, authData, awsSignOut } from "../../../redux/auth/authSlice";
import {
  Typography,
  Input,
  Modal,
  Button,
  Backdrop,
  makeStyles,
  FormControl,
  TextField,
  InputAdornment,
  CircularProgress,
} from "@material-ui/core";
import RegexTextField from "./RegexTextField";
import axios from "axios";
import CloseIcon from "@material-ui/icons/Close";
import Video from "../../../assets/svgjs/Video";
import Review from "../../../assets/svgjs/Review";
import Html from "../../../assets/svgjs/Html";
import QuizIc from "../../../assets/svgjs/Quiz";
import PdfIcon from "../../../assets/svgjs/Pdf";
import EditorJs from "react-editor-js";
import eEditorJS from "@editorjs/editorjs";
import { EDITOR_JS_TOOLS } from "./EditorConstants";
import edjsHTML from "editorjs-html";
import JSZip from "jszip";
import CreateQuiz from "../../../components/CreateQuiz/CreateQuiz";
import produce from "immer";
import swal from "sweetalert";
import shortid from "shortid";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #fff",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "1100px",
    height: "660px",
    borderRadius: ".8rem",
    overflowX: "hidden",
    overflowY: "auto",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.73)",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "98%",
    fontSize: "14px",
  },
  buttonField: {
    fontSize: "12px",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
export default function ObjectPopUp({
  objOpen,
  setObjOpen,
  renderSwitch,
  folder,
  cNugget,
  setNuggets,
  nuggets,
  setEditObj,
  editObj,
  uidx,
}) {
  const classes = useStyles();
  const iniotypes = [
    { type: "Narrative", id: "2", img: "html" },
    { type: "PDF", id: "3", img: "pdf" },
    { type: "Quiz", id: "4", img: "quiz" },
    { type: "Interactivity", id: "5", img: "Interactivity" },
    { type: "Video", id: "6", img: "video" },
    { type: "Audio", id: "7", img: "audio" },
    { type: "Youtube", id: "8", img: "youtube" },
    { type: "Vimeo", id: "9", img: "vimeo" },
    { type: "Skills Training Feedback", id: "10", img: "quiz" },
    { type: "Practical Exam", id: "11", img: "quiz" },
    //{ type: "Practical Practice Training ", id: "12", img: "quiz" },
  ];
  let userDetails = useSelector(authData);
  const [loading, setLoading] = useState(false);
  const [selectType, setSelectType] = useState(true);
  const [otypes, setOtypes] = useState(iniotypes);
  const [selectedFile, setSelectedFile] = useState();
  const refobject = useRef({});
  const [isBookmarkedLoaded, setisBookmarkedLoaded] = useState(false);
  const [typesButtons, setTypeButtons] = useState(true);
  const [quizQuestion, setQuizQuestion] = useState([]);

  const [selectedObj, setSelectedObj] = useState({});
  const onlyAlphanumericRegex = /[^0-9]/gi;
  const instanceRef = useRef(null);
  useEffect(() => {
    // action on update of movies
    let pNuggets = [...nuggets];
    // console.log(pNuggets);
    // for (let index = 0; index < pNuggets.length; index++) {

    //   if (cNugget.uidx === index) {
    //     console.log(pNuggets[index].nuggets);
    //     setNuggets(pNuggets[index].nuggets);
    //   }

    // }
  }, [selectedObj]);
  const handleClose = () => {
    setSelectedObj({});
    setSelectType(true);
    setObjOpen(false);
    setTypeButtons(true);
    setQuizQuestion([]);
    setEditObj({ ...editObj, objectView: false });
    setSelectedFile(undefined);
  };
  const sobjecttype = function (id) {
    let obj = {};
    obj.otherdata = { title: "", desc: "", dur: "", files: "" };
    if (id == "3" || id == 3) {
      obj.pdft = true;
      obj.sobject = "PDF";
      obj.afile = ".pdf";
      obj.otype = "pdf";
      //obj.data = [{"ptitle":"","pdur":"","pfile":""}];
    } else if (id == "7" || id == 7) {
      obj.audiot = true;
      obj.sobject = "Audio";
      obj.otherdata.ytcode = "";
      obj.afile = "audio/*";
      obj.otype = "audio";
    } else if (id == "2" || id == 2) {
      obj.htmlt = true;
      obj.sobject = "Narrative";
      obj.selecthtmltype = true;
      obj.afile = ".html";
      obj.otype = "html";
      //obj.htmldata =  [{"quiloutput":"","htitle":"","hdur":"","hdursecs":"","hfile":""}];
      obj.otherdata.quiloutput = "";
    } else if (id == "5" || id == 5) {
      obj.htmlt = true;
      obj.sobject = "Interactivity";
      obj.selecthtmltype = true;
      obj.afile = ".html, application/zip, application/x-zip-compressed, .zip";
      obj.otype = "Interactivity";
      //obj.htmldata =  [{"quiloutput":"","htitle":"","hdur":"","hdursecs":"","hfile":""}];
      obj.otherdata.quiloutput = "";
    } else if (id == "4" || id == 4) {
      obj.quizt = true;
      obj.sobject = "Quiz";
      obj.qid = "0";
      obj.itemsPerPage = 1;
      obj.noques = false;
      obj.quizid = 1;
      obj.otype = "quiz";
      obj.quizquestions = [];
    } else if (id === "8" || id === 8) {
      obj.sobject = "youtube";
      obj.stype = "youtube";
      obj.otype = "youtube";
    } else if (id === "9" || id === 9) {
      obj.sobject = "vimeo";
      obj.stype = "vimeo";
      obj.otype = "vimeo";
    } else if (id == "10" || id == 10) {
      obj.ptraining = true;
      obj.sobject = "Skills Training Feedback";
      obj.otype = "ptraining";
    } else if (id == "11" || id == 11) {
      obj.ptraining = true;
      obj.sobject = "Practical Exam";
      obj.otype = "pexam";
    } else if (id == "12" || id == 12) {
      obj.ptraining = true;
      obj.sobject = "Practical Practice Traning";
      obj.otype = "ppt";
    } else {
      obj.videot = true;
      obj.sobject = "Video";
      obj.afile = "video/*";
      obj.otype = "video";
    }

    obj.seltype = true;
    obj.error1 = false;
    setSelectedObj(obj);
    if (id != "2" && id != 2) {
      setSelectType(false);
    }
  };
  const isImage = (filename) => {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case "jpg":
      case "png":
      case "jpeg":
        return true;
      default:
        return false;
    }
  };
  function isVideo(filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case "m4v":
      case "avi":
      case "mpg":
      case "mp4":
      case "mov":
      case "mkv":
      case "WMV":
      case "AVCHD":
        // etc
        return true;
      default:
        return false;
    }
  }
  function isInteractivity(filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case "zip":
      case "html":
        return true;
      default:
        return false;
    }
  }
  function isAudio(filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case "mp3":
      case "wav":
      case "msv":
      case "m4p":
        return true;
      default:
        return false;
    }
  }
  function isPDF(filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case "pdf":
        return true;
      default:
        return false;
    }
  }
  function isHTML(filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case "html":
        return true;
      default:
        return false;
    }
  }
  function getExtension(filename) {
    var parts = filename.split(".");
    return parts[parts.length - 1];
  }
  const changeHandler = (event) => {
    // setSelectedFile(new File([""], "filename"));
    if (event.target.files[0] !== undefined) {
      if (
        !isVideo(event.target.files[0].name) &&
        selectedObj.afile === "video/*"
      ) {
        swal("Oops!", "Select correct file format..!", "error");
        return;
      }
      if (
        !isInteractivity(event.target.files[0].name) &&
        selectedObj.afile ===
          ".html, application/zip, application/x-zip-compressed, .zip"
      ) {
        swal("Oops!", "Select correct file format..!", "error");
        return;
      }

      if (!isPDF(event.target.files[0].name) && selectedObj.afile === ".pdf") {
        swal("Oops!", "Select correct file format..!", "error");
        return;
      }
      if (
        !isHTML(event.target.files[0].name) &&
        selectedObj.afile === ".html"
      ) {
        swal("Oops!", "Select correct file format..!", "error");
        return;
      }
      if (
        !isAudio(event.target.files[0].name) &&
        selectedObj.afile === "audio/*"
      ) {
        swal("Oops!", "Select correct file format..!", "error");
        return;
      }
      let uri = URL.createObjectURL(event.target.files[0]);
      console.log(event.target.files[0]);
      setSelectedFile(event.target.files[0]);
      selectedObj.otherdata.files = event.target.files[0].name;
      setSelectedObj(selectedObj);
    }
  };
  const finalSave = async () => {
    selectedObj.otherdata.dur =
      Number(selectedObj.otherdata.min) * 60 +
      Number(selectedObj.otherdata.sec);
    let file;
    let id = Math.floor(Math.random() * (999 - 100 + 1) + 100);
    let filename = "";
    if (selectedObj.stype !== undefined && selectedObj.stype == "chtml") {
      filename =
        Number(Math.floor(Math.random() * (999 - 100 + 1) + 100)) + ".html";
    } else if (selectedObj.otype == "quiz") {
      filename =
        Number(Math.floor(Math.random() * (999 - 100 + 1) + 100)) + ".json";
    } else if (selectedFile !== undefined) {
      filename = id + selectedFile.name;
    }

    let object = {
      otitle: selectedObj.otherdata.title,
      odescription: selectedObj.otherdata.desc,
      otype: selectedObj.otype,
      oduration: selectedObj.otherdata.dur,
      ourl: filename,
      filechanges: true,
      newfile: filename,
    };
    if (
      selectedObj.quizdata != undefined &&
      selectedObj.quizdata.cutoff != undefined
    ) {
      object.cutoff = selectedObj.quizdata.cutoff;
    }

    //alert(selectedObj.otherdata.quesType)
    if (selectedObj.otherdata.quesType !== undefined) {
      object.qtype = selectedObj.otherdata.quesType;
    }
    if (cNugget !== undefined && cNugget.nid !== undefined) {
      if (cNugget.objects.length > 0) {
        object.obj_id = shortid.generate();
        // cNugget.nid +
        // "-" +
        // (Number(
        //   cNugget.objects[cNugget.objects.length - 1].obj_id.substr(
        //     cNugget.objects[cNugget.objects.length - 1].obj_id.length - 1
        //   )
        // ) +
        //   1);
      } else {
        //object.obj_id = cNugget.nid + "-1";
        object.obj_id = shortid.generate();
      }
      if (cNugget.cedit !== undefined) {
        var filetype = filename.split(".").pop();
        object.ourl = object.obj_id + "." + filetype;
      }
    }
    refobject.current = object;

    var body = {
      filename: filename,
      folder: folder,
    };
    if (selectedObj.stype !== undefined && selectedObj.stype == "chtml") {
      body.filetype = "text/html";
      const savedData = await instanceRef.current.save();
      console.log(savedData);
      const edjsParser = edjsHTML();
      // blocks
      object.stype = "chtml";
      file = edjsParser.parse(savedData);
      file = JSON.parse(JSON.stringify(file));
      let tempFile = [];
      let html = ` 
      <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        </head>
      <body>
      `;
      for (let i = 0; i < file.length; i++) {
        html = html + file[i];
        tempFile.push(file[i]);
      }
      html =
        html +
        `
       </body>
      </html>
      `;
      file = html;
      object.fileHtml = tempFile;
      console.log(file);
    } else if (selectedObj.otype == "quiz") {
      file = selectedObj.quizdata;
      object.file = selectedObj.quizdata;
      body.filetype = "application/json";
      console.log(file);
    } else if (selectedObj.otype == "youtube" || selectedObj.otype == "vimeo") {
      object.embeddedcode = selectedObj.otherdata.embeddedcode;
      object.url = "";
    } else if (
      selectedObj.otype !== "ptraining" &&
      selectedObj.otype !== "pexam" &&
      selectedObj.otype !== "ppt"
    ) {
      file = selectedFile;
      object.file = selectedFile;
      body.filetype = selectedFile.type;
    }
    console.log("object===", object);
    //var typejson = {"type" :"uploadfile","file":selectedFile,"body":body };
    setisBookmarkedLoaded(true);
    setSelectedFile(undefined);
    if (
      selectedObj.otype !== "ptraining" &&
      selectedObj.otype !== "pexam" &&
      selectedObj.otype !== "ppt"
    ) {
      uploadfile(body, file);
    } else {
      object.filechanges = false;
      let nuggts = [...nuggets];
      console.log("rrr", nuggts);
      nuggts = produce(nuggts, (v) => {
        v[cNugget.uidx].nuggets[cNugget.ids].nchanges = true;
        v[cNugget.uidx].nuggets[cNugget.ids].objects.push(object);
      });

      setNuggets(nuggts);
      setTypeButtons(true);
      setObjOpen(false);
      setQuizQuestion([]);
      setisBookmarkedLoaded(false);
      editObj.meditmode = true;
      editObj.objectView = false;
      setEditObj({ ...editObj });
      handleClose();
    }
  };
  const checkData = async () => {
    // console.log(JSON.stringify(selectedObj.stype,null,2))

    console.log("selectedObj", selectedObj);

    if (
      selectedObj.otherdata.title === undefined ||
      selectedObj.otherdata.title == "" ||
      selectedObj.otherdata.title.replace(/\s/g, "").length === 0
    ) {
      selectedObj.otherdata.eval = false;
      selectedObj.otherdata.dsval = false;
      selectedObj.otherdata.mval = false;
      selectedObj.otherdata.sval = false;
      selectedObj.otherdata.tval = true;

      setSelectedObj((prevselectedObj) => ({
        ...prevselectedObj,
        ...selectedObj,
      }));
      console.log(selectedObj);
      return;
    }

    if (
      selectedObj.otherdata.desc === undefined ||
      selectedObj.otherdata.desc == "" ||
      selectedObj.otherdata.desc.replace(/\s/g, "").length === 0
    ) {
      selectedObj.otherdata.dsval = true;
      selectedObj.otherdata.tval = false;
      selectedObj.otherdata.eval = false;
      selectedObj.otherdata.mval = false;
      selectedObj.otherdata.sval = false;
      setSelectedObj((prevselectedObj) => ({
        ...prevselectedObj,
        ...selectedObj,
      }));
      return;
    }
    if (
      (selectedObj.otherdata.min === undefined ||
        selectedObj.otherdata.min == "" ||
        selectedObj.otherdata.min.replace(/\s/g, "").length === 0) &&
      selectedObj.otype != "ptraining" &&
      selectedObj.otype != "pexam" &&
      selectedObj.otype != "ppt"
    ) {
      selectedObj.otherdata.dsval = false;
      selectedObj.otherdata.tval = false;
      selectedObj.otherdata.eval = false;
      selectedObj.otherdata.mval = true;
      setSelectedObj((prevselectedObj) => ({
        ...prevselectedObj,
        ...selectedObj,
      }));
      return;
    }
    if (
      (selectedObj.otherdata.sec === undefined ||
        selectedObj.otherdata.sec == "" ||
        selectedObj.otherdata.sec.replace(/\s/g, "").length === 0) &&
      selectedObj.otype != "ptraining" &&
      selectedObj.otype != "pexam" &&
      selectedObj.otype != "ppt"
    ) {
      selectedObj.otherdata.dsval = false;
      selectedObj.otherdata.tval = false;
      selectedObj.otherdata.mval = false;
      selectedObj.otherdata.eval = false;
      selectedObj.otherdata.sval = true;
      setSelectedObj((prevselectedObj) => ({
        ...prevselectedObj,
        ...selectedObj,
      }));
      return;
    }
    if (
      selectedObj.otype !== "ptraining" &&
      selectedObj.otype !== "pexam" &&
      selectedObj.otype !== "ppt" &&
      selectedObj.sobject !== "youtube" &&
      selectedObj.sobject !== "vimeo" &&
      selectedObj.stype !== "chtml"
    ) {
      if (selectedFile === undefined) {
        selectedObj.otherdata.dsval = false;
        selectedObj.otherdata.tval = false;
        selectedObj.otherdata.mval = false;
        selectedObj.otherdata.sval = false;
        selectedObj.otherdata.eval = false;
        selectedObj.ferror = true;
        setSelectedObj((prevselectedObj) => ({
          ...prevselectedObj,
          ...selectedObj,
        }));
        return;
      }
    }

    if (selectedObj.stype !== undefined && selectedObj.stype == "chtml") {
      const savedData = await instanceRef.current.save();

      if (savedData.blocks.length === 0) {
        selectedObj.otherdata.dsval = false;
        selectedObj.otherdata.tval = false;
        selectedObj.otherdata.mval = false;
        selectedObj.otherdata.sval = false;
        selectedObj.otherdata.eval = false;
        selectedObj.ferror = true;
        setSelectedObj((prevselectedObj) => ({
          ...prevselectedObj,
          ...selectedObj,
        }));
        return;
      }
    } else if (
      selectedObj.sobject == "Interactivity" ||
      (selectedFile === undefined &&
        selectedObj.otype !== "ptraining" &&
        selectedObj.otype !== "pexam" &&
        selectedObj.otype !== "ppt" &&
        selectedObj.sobject !== "youtube" &&
        selectedObj.sobject !== "vimeo")
    ) {
      if (selectedFile === undefined) {
        selectedObj.otherdata.dsval = false;
        selectedObj.otherdata.tval = false;
        selectedObj.otherdata.mval = false;
        selectedObj.otherdata.sval = false;
        selectedObj.otherdata.eval = false;
        selectedObj.ferror = true;
        setSelectedObj((prevselectedObj) => ({
          ...prevselectedObj,
          ...selectedObj,
        }));
        return;
      }

      console.log(selectedFile);
      JSZip.loadAsync(selectedFile).then(function (content) {
        var tmp = JSON.stringify(content);
        let fileexist = false;
        var t1 = tmp.toString();
        t1 = JSON.parse(t1);

        console.log(t1);
        try {
          if (t1.files["index.html"].name) {
            console.log(t1.files["index.html"].name);
            fileexist = true;
          }
        } catch (e) {
          fileexist = false;
          console.error(e);
        }
        if (!fileexist) {
          selectedObj.otherdata.dsval = false;
          selectedObj.otherdata.tval = false;
          selectedObj.otherdata.mval = false;
          selectedObj.otherdata.sval = false;
          selectedObj.otherdata.eval = false;
          selectedObj.ferror = true;
          setSelectedObj((prevselectedObj) => ({
            ...prevselectedObj,
            ...selectedObj,
          }));
          swal("Oops!", "Select correct file format..!", "error");
          return;
        } else {
          finalSave();
        }
      });
    } else if (
      selectedFile === undefined &&
      selectedObj.otype !== "ptraining" &&
      selectedObj.otype !== "pexam" &&
      selectedObj.otype !== "ppt" &&
      selectedObj.stype !== "vimeo" &&
      selectedObj.stype !== "youtube"
    ) {
      selectedObj.otherdata.dsval = false;
      selectedObj.otherdata.tval = false;
      selectedObj.otherdata.mval = false;
      selectedObj.otherdata.sval = false;
      selectedObj.otherdata.eval = false;
      selectedObj.ferror = true;
      setSelectedObj((prevselectedObj) => ({
        ...prevselectedObj,
        ...selectedObj,
      }));
      return;
    } else if (selectedObj.stype == "vimeo" || selectedObj.stype == "youtube") {
      if (
        selectedObj.otherdata.embeddedcode === undefined ||
        selectedObj.otherdata.embeddedcode == "" ||
        selectedObj.otherdata.embeddedcode.replace(/\s/g, "").length === 0
      ) {
        selectedObj.otherdata.dsval = false;
        selectedObj.otherdata.tval = false;
        selectedObj.otherdata.mval = false;
        selectedObj.otherdata.sval = false;
        selectedObj.otherdata.eval = true;

        setSelectedObj((prevselectedObj) => ({
          ...prevselectedObj,
          ...selectedObj,
        }));
        console.log(selectedObj);
        return;
      }
    }
    if (selectedObj.sobject !== "Interactivity") {
      finalSave();
    }
  };
  async function uploadfile(body, file) {
    const bodyParam = {
      body,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    let refObj = { ...refobject.current };

    try {
      const preSignedData = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_PRESIGNED_URL,
        //"/getpreSignedURL",
        bodyParam,
      );
      let ftype = "";
      if (selectedObj.stype !== undefined && selectedObj.stype == "chtml") {
        ftype = "text/html";
      } else if (selectedObj.otype == "quiz") {
        ftype = "application/json";
        if (selectedObj.otherdata.quesType == "3") {
          delete file.attempt["1"].catList;
          delete file.attempt["2"].catList;
          delete file.attempt["3"].catList;
          delete file.attempt["4"].catList;
          delete file.attempt["5"].catList;
          refObj.oduration = file.attempt["1"].qitems.length * 60;
        } else {
          refObj.oduration = file.qitems.length * 60;
        }
      } else if (selectedFile !== undefined) {
        ftype = selectedFile.type;
      } else {
        ftype = "application/json";
      }

      axios
        .put(preSignedData, file, {
          headers: {
            "Content-Type": ftype,
            "Cache-Control": "no-cache no-store must-revalidate",
          },
        })
        .then((response) => {
          let nuggts = [...nuggets];

          console.log("cNugget", cNugget);

          nuggts = produce(nuggts, (v) => {
            console.log("success addobject", cNugget.uidx, v, cNugget);
            v[cNugget.uidx].nuggets[cNugget.ids].nchanges = true;
            if (selectedObj.otype != "quiz") {
              v[cNugget.uidx].nuggets[cNugget.ids].objects.push(
                refobject.current,
              );
            } else {
              v[cNugget.uidx].nuggets[cNugget.ids].objects.push(refObj);
            }
          });
          console.log(JSON.stringify(refobject.current, null, 2));
          // nuggets[cNugget.ids].nchanges = true;
          // nuggets[cNugget.ids].objects.push(
          //   refobject.current
          // );
          setNuggets(nuggts);
          setTypeButtons(true);
          setObjOpen(false);
          setQuizQuestion([]);
          setisBookmarkedLoaded(false);
          editObj.meditmode = true;
          editObj.objectView = false;
          setEditObj({ ...editObj });
          handleClose();
        })
        .catch((error) => {
          setisBookmarkedLoaded(false);
          console.error("There was an error!", error);
        });
    } catch (error) {
      // alert(JSON.stringify(error));
      console.error("Not Uploaded", error.message);
    }
  }
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={objOpen}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className={Cviewstyle.modalpopup + " modal-content"}>
            <div
              className="modal-header"
              style={{ backgroundColor: "#393939", color: "#fff" }}
            >
              <h3 className="modal-title">
                Add Objects{" "}
                {selectedObj.sobject != "" && (
                  <span> - {selectedObj.sobject}</span>
                )}
              </h3>
              <button
                onClick={handleClose}
                style={{
                  border: "none",
                  background: "transparent",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                <CloseIcon color="#fff" fontSize="large" />
              </button>
            </div>
            <div className="modal-body">
              <div className={classes.ratingroot}>
                {selectType ? (
                  <div style={{ margin: "0px 50px 0px 50px" }}>
                    <p
                      style={{
                        fontSize: "15px",
                        fontWeight: "bold",
                        margin: "10px 0",
                        color: "#484848",
                        fontfamily: "MyWebFont1",
                      }}
                    >
                      Please select the type of object
                    </p>
                    <div className={Cviewstyle.objbtnsmain}>
                      <div className={Cviewstyle.objbtns}>
                        {selectedObj.sobject === undefined && (
                          <>
                            {otypes.map((type, oind) => (
                              <Button
                                variant="outlined"
                                className={Cviewstyle.objecttype}
                                style={{ fontSize: "14px", fontWeight: "bold" }}
                                onClick={() => sobjecttype(type.id)}
                              >
                                <span style={{ marginRight: "5px" }}>
                                  {renderSwitch(type.img)}
                                </span>
                                {type.type}
                              </Button>
                            ))}
                          </>
                        )}
                        {selectedObj.sobject !== undefined && (
                          <>
                            <Button
                              variant="contained"
                              color="primary"
                              style={{ marginRight: "10px" }}
                              onClick={() => {
                                selectedObj.stype = "chtml";
                                setSelectedObj(
                                  (prevselectedObj) => selectedObj,
                                );
                                setSelectType(false);
                              }}
                            >
                              Create HTML
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => {
                                selectedObj.stype = "uhtml";
                                setSelectedObj(
                                  (prevselectedObj) => selectedObj,
                                );
                                setSelectType(false);
                              }}
                            >
                              Upload HTML
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {selectedObj.seltype && selectedObj.sobject != "Quiz" && (
                      <div>
                        <div
                          style={{ margin: "20px 60px", overflow: "hidden" }}
                        >
                          {selectedObj.error1 && (
                            <p className={Cviewstyle.verror1}>
                              {selectedObj.sobject}
                              title cannot be empty
                            </p>
                          )}

                          <form autoComplete="off">
                            <TextField
                              label="Title"
                              id="outlined-margin-normal"
                              className={classes.textField}
                              error={selectedObj.otherdata.tval}
                              helperText={
                                selectedObj.otherdata.tval
                                  ? "Please Enter Title"
                                  : ""
                              }
                              margin="normal"
                              variant="outlined"
                              onChange={(e) => {
                                selectedObj.otherdata.title = e.target.value;
                                setSelectedObj(selectedObj);
                              }}
                              inputProps={{ style: { fontSize: "14px" } }}
                              InputLabelProps={{ style: { fontSize: "14px" } }}
                            />
                            <TextField
                              label="Description"
                              id="outlined-margin-normal"
                              className={classes.textField}
                              error={selectedObj.otherdata.dsval}
                              helperText={
                                selectedObj.otherdata.dsval
                                  ? "Please Enter Description"
                                  : ""
                              }
                              margin="normal"
                              variant="outlined"
                              onChange={(e) => {
                                selectedObj.otherdata.desc = e.target.value;
                                setSelectedObj(selectedObj);
                              }}
                              inputProps={{ style: { fontSize: "14px" } }}
                              InputLabelProps={{ style: { fontSize: "14px" } }}
                            />

                            {selectedObj.otype != "ptraining" &&
                              selectedObj.otype != "pexam" &&
                              selectedObj.otype != "ppt" && (
                                <>
                                  <RegexTextField
                                    regex={onlyAlphanumericRegex}
                                    label="Duration"
                                    error={selectedObj.otherdata.mval}
                                    helperText={
                                      selectedObj.otherdata.mval
                                        ? "Please Enter Min"
                                        : ""
                                    }
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          Min
                                        </InputAdornment>
                                      ),
                                    }}
                                    onChange={(e) => {
                                      selectedObj.otherdata.min =
                                        e.target.value;
                                      setSelectedObj(selectedObj);
                                    }}
                                    inputProps={{ style: { fontSize: "14px" } }}
                                    InputLabelProps={{
                                      style: { fontSize: "14px" },
                                    }}
                                  />
                                  <RegexTextField
                                    regex={onlyAlphanumericRegex}
                                    label=""
                                    error={selectedObj.otherdata.sval}
                                    helperText={
                                      selectedObj.otherdata.sval
                                        ? "Please Enter Sec"
                                        : ""
                                    }
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          Sec
                                        </InputAdornment>
                                      ),
                                    }}
                                    onChange={(e) => {
                                      console.log(selectedObj);
                                      selectedObj.otherdata.sec =
                                        e.target.value;
                                      setSelectedObj(selectedObj);
                                    }}
                                    inputProps={{ style: { fontSize: "14px" } }}
                                    InputLabelProps={{
                                      style: { fontSize: "14px" },
                                    }}
                                  />
                                </>
                              )}

                            {(selectedObj.sobject === "youtube" ||
                              selectedObj.sobject === "vimeo") && (
                              <TextField
                                label="Embed ID"
                                id="outlined-margin-normal"
                                className={classes.textField}
                                error={selectedObj.otherdata.eval}
                                helperText={
                                  selectedObj.otherdata.eval
                                    ? "Please Enter Embed ID"
                                    : ""
                                }
                                margin="normal"
                                variant="outlined"
                                onChange={(e) => {
                                  selectedObj.otherdata.embeddedcode =
                                    e.target.value;
                                  setSelectedObj(selectedObj);
                                }}
                                inputProps={{ style: { fontSize: "14px" } }}
                                InputLabelProps={{
                                  style: { fontSize: "14px" },
                                }}
                              />
                            )}
                          </form>
                        </div>

                        {selectedObj.stype == "chtml" && (
                          <>
                            {selectedObj.ferror && (
                              <p
                                style={{
                                  color: "red",
                                  margin: "0 60px",
                                  textAlign: "left",
                                }}
                              >
                                Please enter some data.{" "}
                              </p>
                            )}
                            <div
                              style={{
                                height: "260px",
                                border: "1px solid #ddd",
                                margin: "0px 60px",
                                padding: "6px 28px",
                                overflow: "hidden auto",
                              }}
                            >
                              <EditorJs
                                tools={EDITOR_JS_TOOLS}
                                instanceRef={(instance) =>
                                  (instanceRef.current = instance)
                                }
                              />
                            </div>
                          </>
                        )}

                        {selectedObj.otype !== "ptraining" &&
                          selectedObj.otype !== "pexam" &&
                          selectedObj.otype !== "ppt" &&
                          (selectedObj.stype === undefined ||
                            (selectedObj.stype != "chtml" &&
                              selectedObj.stype != "youtube" &&
                              selectedObj.stype != "vimeo")) && (
                            <>
                              <p className={Cviewstyle.pvalid}>
                                Please select a{" "}
                                {selectedObj.sobject == "Narrative"
                                  ? "HTML"
                                  : selectedObj.sobject}{" "}
                                to upload
                              </p>
                              <div className={Cviewstyle.insidediv}>
                                <div className={Cviewstyle.centeritem}>
                                  <input
                                    type="file"
                                    id="files"
                                    style={{
                                      visibility: "hidden",
                                      position: "absolute",
                                    }}
                                    onChange={changeHandler}
                                    accept={selectedObj.afile}
                                  />
                                  <label for="files">
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      component="span"
                                      className={classes.buttonField}
                                    >
                                      Browse
                                    </Button>
                                  </label>
                                </div>

                                {selectedObj.otherdata.files != "" && (
                                  <p className={Cviewstyle.pfile}>
                                    {selectedObj.otherdata.files}{" "}
                                  </p>
                                )}
                                {selectedObj.otherdata.files == "" && (
                                  <p className={Cviewstyle.pfile}>
                                    {selectedObj.sobject} file not selected{" "}
                                  </p>
                                )}
                                {selectedObj.ferror && (
                                  <p
                                    className={Cviewstyle.pfile}
                                    style={{ color: "red" }}
                                  >
                                    {" "}
                                    Please select file{" "}
                                  </p>
                                )}
                              </div>
                            </>
                          )}
                      </div>
                    )}
                    {selectedObj.sobject == "Quiz" && (
                      <CreateQuiz
                        selectedObj={selectedObj}
                        setSelectedObj={setSelectedObj}
                        finalSave={finalSave}
                        folder={folder}
                        setTypeButtons={setTypeButtons}
                        typesButtons={typesButtons}
                        quizQuestion={quizQuestion}
                        setQuizQuestion={setQuizQuestion}
                      />
                    )}
                  </>
                )}
              </div>
              {isBookmarkedLoaded && (
                <Backdrop className={classes.backdrop} open={true}>
                  <CircularProgress color="inherit" />
                </Backdrop>
              )}
            </div>
            <div className={Cviewstyle.modalfooter + " " + "modal-footer"}>
              {!selectType && selectedObj.sobject != "Quiz" && (
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    fontSize: "14px",
                  }}
                  onClick={() => checkData()}
                >
                  Save
                </Button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
